import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledHealthcareInstitutionLogo = styled(StyledFlex)`
   grid-row: span 2;
   height: 100%;
   border-radius: 16px;
   background-color: ${(props) => props.theme.white};
`;
StyledHealthcareInstitutionLogo.displayName = 'StyledHealthcareInstitutionLogo';
